import React from 'react';

interface BouncingDotsProps {
  className?: string;
  style?: React.CSSProperties;
}

export const BouncingDots: React.FC<BouncingDotsProps> = ({ className, style }) => {
  // Generate unique animation name to avoid conflicts
  const animationName = `bounce-${Math.random().toString(36).substr(2, 9)}`;
  
  return (
    <>
      <style>{`
        @keyframes ${animationName}-1 {
          0%, 40%, 100% {
            opacity: 0.4;
            transform: translateY(0px);
          }
          20% {
            opacity: 1;
            transform: translateY(-10px);
          }
        }
        
        @keyframes ${animationName}-2 {
          0%, 20%, 60%, 100% {
            opacity: 0.4;
            transform: translateY(0px);
          }
          40% {
            opacity: 1;
            transform: translateY(-10px);
          }
        }
        
        @keyframes ${animationName}-3 {
          0%, 40%, 80%, 100% {
            opacity: 0.4;
            transform: translateY(0px);
          }
          60% {
            opacity: 1;
            transform: translateY(-10px);
          }
        }
      `}</style>
      <div 
        className={className}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '4px',
          padding: '8px 0',
          minHeight: '24px',
          ...style
        }}
      >
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            style={{
              width: '8px',
              height: '8px',
              backgroundColor: 'var(--color-text-secondary)', // Subtle gray color for professional look
              borderRadius: '50%',
              animation: `${animationName}-${index + 1} 1.5s infinite ease-in-out`,
              flexShrink: 0,
              opacity: 1,
              display: 'block',
            }}
          />
        ))}
      </div>
    </>
  );
};